import React from 'react';
import {
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
  TextLink,
} from '../../../../../../core';
import { Demographics, formatPatientName } from '../../../../../../api/models';

export interface DemographicsDisplayProps {
  demographics: Demographics;
  onEditDemographics: () => void;
}

const DemographicsDisplay: React.FC<DemographicsDisplayProps> = (
  props: DemographicsDisplayProps
) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      <Paragraph text={`Name: ${formatPatientName(props.demographics)}`} />
      <Paragraph
        text={`Date of birth: ${props.demographics.dateOfBirth ?? ''}`}
      />
      <Paragraph text={`Preferred sex: ${props.demographics.preferredSex}`} />
      <TextLink
        caption="Edit patient information"
        onClick={() => props.onEditDemographics()}
      />
    </StackedColumn>
  );
};

export default DemographicsDisplay;
